module.exports = __webpack_public_path__ + "img/shib.d5762462.svg";